import { render, staticRenderFns } from "./GroupBuyIndex.vue?vue&type=template&id=4ecb2b39&scoped=true"
import script from "./GroupBuyIndex.vue?vue&type=script&lang=js"
export * from "./GroupBuyIndex.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyIndex.vue?vue&type=style&index=0&id=4ecb2b39&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecb2b39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecb2b39')) {
      api.createRecord('4ecb2b39', component.options)
    } else {
      api.reload('4ecb2b39', component.options)
    }
    module.hot.accept("./GroupBuyIndex.vue?vue&type=template&id=4ecb2b39&scoped=true", function () {
      api.rerender('4ecb2b39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/groupBuy/GroupBuyIndex.vue"
export default component.exports